/** Clave de entidad para notas CP (alineada con cierre CP: D_ pedido, P_ producto, M_ muestra). */
export function getCpNotasEntityKey({
  productId = null,
  idMuestra = null,
  idPresupuestoA3Pedido = null,
} = {}) {
  if (
    idPresupuestoA3Pedido != null &&
    Number.isFinite(Number(idPresupuestoA3Pedido))
  ) {
    return `D_${Number(idPresupuestoA3Pedido)}`;
  }
  if (productId != null && Number.isFinite(Number(productId))) {
    return `P_${Number(productId)}`;
  }
  if (idMuestra != null && Number.isFinite(Number(idMuestra))) {
    return `M_${Number(idMuestra)}`;
  }
  return null;
}

/** Mapea fila de count-all del API a clave de badge. */
export function getCpNotasCountKeyFromApiRow(row) {
  if (
    row?.IdPresupuestoA3Pedido != null &&
    Number.isFinite(Number(row.IdPresupuestoA3Pedido))
  ) {
    return `D_${Number(row.IdPresupuestoA3Pedido)}`;
  }
  if (row?.ProductId != null && Number.isFinite(Number(row.ProductId))) {
    return `P_${Number(row.ProductId)}`;
  }
  if (row?.ID_MUESTRA != null && Number.isFinite(Number(row.ID_MUESTRA))) {
    return `M_${Number(row.ID_MUESTRA)}`;
  }
  return null;
}
